import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { Copy } from 'lucide-react';
import { useState } from 'react';
import type { Answer } from '../api/schemas';

const plainText = (a: Answer) =>
  `${a.text.replace(/\[\d+\]/g, '')}\n\nSources:\n${a.citations.map((c) => `${c.title}, ${c.publishDate}, p.${c.page}`).join('\n')}`;

/** Copy the answer with its sources. */
export function AnswerActions({ answer }: { answer: Answer }) {
  const [toast, setToast] = useState<string | null>(null);

  const copy = () => {
    navigator.clipboard.writeText(plainText(answer)).then(
      () => { setToast('Answer and sources copied.'); },
      () => { setToast('Copy failed. Select the text instead.'); },
    );
  };

  return (
    <>
      <Button size="small" startIcon={<Copy size={14} />} onClick={copy} sx={actionSx}>Copy</Button>
      <Snackbar open={toast !== null} autoHideDuration={4000} onClose={() => { setToast(null); }} message={toast} />
    </>
  );
}

const actionSx = {
  minHeight: 30,
  ml: -1,
  px: 1,
  fontSize: '0.78125rem',
  color: 'text.secondary',
  '&:hover': { color: 'text.primary', bgcolor: 'surface.subtle' },
} as const;
